<template>
  <div class="container">
    <loading :active='isLoading' :is-full-page="fullPage" :loader='loader' />
    <div class="login_body">
      <div class="login_box">
        <div class="text-center">
          <img src="../../assets/images/Logo.svg" width="100" height="100" />
          <h4 class="text-white mt-1 mb-1">Admin Login</h4>
          <p class="text-white">Please login to your account</p>
        </div>
        <form @submit.prevent="processForm">
          <!-- error messages for form validation -->
          <p v-if="errors.length" style="color:white;">
            <b>Please correct the following error(s):</b>
            <ul>
              <li v-for="(error, index) in errors" :key="index">{{error}}</li>
            </ul>
          </p>
          <div class="mb-3 position-relative">
            <input
              type="email"
              class="form-control bg_input pl_25px"
              placeholder="email"
              v-model="credential"
            />
            <i class="far fa-user input_icon"></i>
          </div>
          <div class="mb-3 position-relative">
            <input
              type="password"
              class="form-control bg_input pl_25px"
              placeholder="Password"
              v-model="password"
            />
            <i class="fa fa-lock input_icon"></i>
          </div>
          <div class="mb-3 position-relative">
            <button
              type="submit"
              class="btn btn-primary rounded-pill w-100"
              
            >
              Login
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";

export default {
  name: "Login",
  components: { Loading },
  data() {
    return {
      errors: [],
      credential: undefined,
      password: undefined,
      //for loader
      isLoading: false,
      fullPage: true,
      loader: "bars",
    };
  },

  methods: {
    processForm() {
      if (this.checkForm()) {
        this.login();
      }
    },
    checkForm(e) {
      if (this.credential && this.password) {
        return true;
      }
      this.errors = [];
      if (!this.credential) {
        this.errors.push("email required.");
        return false;
      }
      if (!this.password) {
        this.errors.push("password required.");
        return false;
      }
      e.preventDefault();
      return false;
    },
    async login() {
      this.isLoading = true;
      try {
        const res = await axios.post(
          this.$baseUrl +
            this.$api +
            this.$version1 +
            this.$auth +
            "/login-admin",
          {
            user_name: this.credential,
            password: this.password,
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        this.isLoading = false;
        console.log("working");
        if (res.status == 200) {
          console.log(res.data);
          localStorage.setItem(this.$tokenKey, res.data.token);
          localStorage.setItem(this.$idKey, res.data.user.id);
          localStorage.setItem(this.$profileImage, res.data.user.image_url);
          this.$router.push("/home");
        } else if (res.status == 422) {
          this.$vToastify.info("We couldn't verify your account details.");
        } else {
          this.$vToastify.info(
            "Something went wrong, please refresh and try again."
          );
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
  },
};
</script>

<style>
</style>